/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const ApiKeyUpdateAnnotationsRequest: core.serialization.Schema<
    serializers.ApiKeyUpdateAnnotationsRequest.Raw,
    Omit<Truvity.ApiKeyUpdateAnnotationsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace ApiKeyUpdateAnnotationsRequest {
    export interface Raw {
        annotations: Record<string, string>;
    }
}
